import { useQuery } from '@tanstack/react-query'
import { BetAccount } from '@mobi/api-types'
import { queryKeys } from '../../../Utils'
import { get } from '../../../Utils/network'

type UseBetAccountProps<T> = {
  queryKey?: string
  enabled?: boolean
  queryFn: () => Promise<T>
  onSuccess?: (data: T) => void
}

export function useBetAccount<T>(options: UseBetAccountProps<T>) {
  return useQuery({
    queryKey: [options.queryKey || queryKeys.betAccount],
    queryFn: options.queryFn,
    gcTime: 0, // Defer to rwwa-data-access for caching
    enabled: options.enabled,
    refetchOnWindowFocus: false,
  })
}

export async function fetchBetAccount(): Promise<BetAccount> {
  return await get<BetAccount>(`/$_/api/account/getBetAccountDetails`)
}
